module.exports = __webpack_public_path__ + "img/knewidea2.d2597e0e.png";